<div class="d-flex justify-content-between align-items-baseline gap-3 container flex-grow-1"
     [ngClass]="{
        current: isCurrent,
        new: isNew,
        'has-upgrade-text': (isNew || (!required && isCurrent && !isSelected)) && addText,
    }">
    @if (isCurrent) {
        <span class="label">{{ currentText }} <i class="fas fa-circle-check"></i></span>
    }
    @if (isNew) {
        <span class="label">{{ newText }}</span>
    }
    <div class="content">
        <ng-content></ng-content>
    </div>
    <span class="checkbox"
          role="button"
          (click)="toggleSelection()">
        <i class="fas fa-fw"
           [ngClass]="{ 'fa-check': isSelected }"></i>
    </span>
    @if (isNew && addText) {
        <span class="upgrade-text">{{ addText }}</span>
    }
    @if (!required && isCurrent && !isSelected && removeText) {
        <span class="remove-text">{{ removeText }}</span>
    }
    @if (isCurrent && isUpdated && updateText) {
        <span class="remove-text">{{ updateText }}</span>
    }
</div>
